import { ofType } from "redux-observable";
import { switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { utilPersistence } from "../../../utils/utilPersistence";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionContractInfo } from "../actionContractInfo";
export var epicContractStartCooldown = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.StartCooldown), switchMap(function (action) {
        var cooldownTimeStamp = utilTime.remainingTimeToTimestamp(action.cooldownTime);
        var contractData = {
            cooldownTime: cooldownTimeStamp,
        };
        utilPersistence.setValue(IdPersistence.ContractData, contractData);
        return [];
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractStartCooldown.ts
// module id = 1999
// module chunks = 3